<svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [class]="position()">
    <path
        d="M2.8123 10.1187C2.6998 10.1187 2.5873 10.0812 2.5123 9.98748C2.34355 9.81873 2.34355 9.55623 2.5123 9.38748L8.19355 3.70623H3.65605C3.43105 3.70623 3.24355 3.51873 3.24355 3.29373C3.24355 3.06873 3.43105 2.88123 3.65605 2.88123H9.1873C9.4123 2.88123 9.59981 3.06873 9.59981 3.29373V8.86248C9.59981 9.08748 9.4123 9.27498 9.1873 9.27498C8.9623 9.27498 8.7748 9.08748 8.7748 8.86248V4.34373L3.1123 10.0062C3.0373 10.0812 2.9248 10.1187 2.8123 10.1187Z"
        [attr.fill]="color()" />
</svg>
